export enum AutopilotDistanceUnitsEnum {
    None,
    meters,
    km,
    nm
}